<template>
    <v-app-bar app clipped-left clipped-right dark color="blue-grey darken-4" >
      <!-- @contextmenu.prevent="handleContextMenu" -->
    <!-- <v-app-bar app clipped-left clipped-right dark color="#01579b" > -->

      <!-- <v-tooltip bottom>
        <template v-slot:activator="{ on }"> -->
        <v-btn class="ml-3" icon @click="toggleDrawer(!drawer)">
            <v-icon >mdi-menu</v-icon> 
        </v-btn>
        <!-- </template>
        <span>Menu</span>
    </v-tooltip> -->
    <v-tooltip bottom>
        <template v-slot:activator="{ on }">
        <v-btn class="ml-3" href="/home" v-on="on" icon>
            <v-icon >mdi-home</v-icon> 
        </v-btn>
        </template>
        <span>ホームに戻る</span>
    </v-tooltip>
    <v-tooltip bottom >
        <template v-slot:activator="{ on : tooltip }">
        <v-menu offset-y>
        <template v-slot:activator="{ on : menu, attrs }">
            <v-btn
            icon
            dark
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>mdi-apps</v-icon>
            </v-btn>
        </template>
        <v-list dense min-width="300" elevation="5">
            <v-container fluid>
                    <v-list-item-group  v-model="menu">
                    <v-row>
                        <v-col cols="12" md="12" sm="12" xs="12">
                        <v-subheader>PAGES</v-subheader>
                        <v-divider></v-divider>
                          <v-list-item
                            v-for="(item, pp) in items"
                            :key="pp"
                            :href="`/${item.to}`"
                          >
                            <v-list-item-icon>
                                <v-icon v-text="item.icon"></v-icon>
                            </v-list-item-icon>
                            <v-list-item-content>
                                <v-list-item-title v-text="item.text"></v-list-item-title>
                            </v-list-item-content>
                        </v-list-item>
                        </v-col>
                    </v-row>
                    </v-list-item-group>
            </v-container>
        </v-list>
        </v-menu>
        </template>
        <span>Menu</span>
    </v-tooltip>

    <v-toolbar-title> <span class="overline">CAD REQUEST V2.{{ verMasterHeader }} - MASTER SETTINGS </span> </v-toolbar-title>
    <v-app-bar-title>
        <v-alert
          class="mt-4 ml-3"
          transition="scroll-x-transition"
          v-model="alert"
          dense
          dismissible
          color="#04b8f7"
          border="left"
          width="425px"
          elevation="2"
          colored-border
          icon="mdi-alert-circle"
          >新バージョンにアップデートしました。
          2.{{ verMasterHeader }}
        </v-alert>
    </v-app-bar-title>
    
    
    
    
    <v-spacer></v-spacer>

    <v-app-bar-title>
      <v-alert
          v-model="reminder"
          class="mt-4 ma-n1 ml-n2"
          transition="scroll-x-transition"
          colored-border
          width="530px"
          dense
          dark
          color="#04b8f7"
          border="right"
          elevation="2"
          icon="mdi-alert-circle">
        <span class="textPosition">
          バージョンが古い場合またはページが開かない場合は、Ctrl+F5にて更新してください。
        </span>
      </v-alert>
    </v-app-bar-title>


    <!-- REMINDER -->
    <v-tooltip bottom color="white">
      <template v-slot:activator="{on,attrs}">
        <v-btn icon medium class="mr-3" >
          <v-icon
            @click="reminder = !reminder"
            color="#04b8f7"
            medium
            v-bind="attrs"
            v-on="on">
            mdi-exclamation-thick</v-icon>
        </v-btn>
      </template>
        <span class="black--text">Reminder</span>
    </v-tooltip>

    <!-- FEEDBACK -->
    <v-tooltip bottom color="white">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="feedbackOpen()" icon small class="mr-3">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-message-reply-text-outline
          </v-icon>
        </v-btn>

      </template>
      <span class="black--text">Feedback Tab</span>
    </v-tooltip>

    <!-- SYSTEM LOGS -->
    <v-tooltip bottom color="white">
      <template v-slot:activator="{ on, attrs }">
        <v-btn @click="logOpen()" icon small class="mr-5">
          <v-icon
            medium
            v-bind="attrs"
            v-on="on">
            mdi-information-outline
          </v-icon>
        </v-btn>

      </template>
      <span class="black--text">System Logs</span>
    </v-tooltip>

    <div class="text-center">
      <span class="caption"><b>{{ authUser.name }}</b></span><br/>
      <span class="caption">{{ authUser.type }}</span>
    </div>
    

    <v-tooltip bottom>
        <template v-slot:activator="{ on : tooltip }">
        <v-menu offset-y max-width="300">
        <template v-slot:activator="{ on : menu, attrs }">
            <v-btn
            icon
            dark
            v-bind="attrs"
            v-on="{ ...tooltip, ...menu }"
            >
            <v-icon>mdi-account-circle</v-icon>
            </v-btn>
        </template>
        <v-list dense width="120">
            <v-subheader>ACCOUNT</v-subheader>
            <v-list-item-group>
                <v-list-item >
                <v-list-item-content>
                    <v-form id="logOut" method="POST" action="/logout">
                        <input type="hidden" name="_token" :value="csrf">
                        <v-icon>mdi-logout</v-icon>
                        <input  class="caption" text type="submit" value="Logout" depressed @click="logOut()">
                    </v-form>
                </v-list-item-content>
                </v-list-item>
            </v-list-item-group>
        </v-list>
        </v-menu>
        </template>
        <span>Menu</span>
    </v-tooltip>
    </v-app-bar>
</template>
<script>
import { mapState , mapActions } from 'vuex';
import moment from 'moment';

export default {
  props: {
      drawer:{
          type: Boolean
      },
  },

  data: () => ({ 
    feedbackData : [],
    createdDate : (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
    feedbackMessages : 0,
    dateToday: moment().format("YYYY-MM-DD"),
    alert : false,
    reminder: false,
    verMasterHeader : '',
    csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
    menu: null,
    items:[
            {text:'CAD Request', icon:'mdi-content-paste', to:'cadrequest'},
            {text:'View Table', icon:'mdi-table-eye', to:'viewtable'},
            // {text:'Hello', icon:'mdi-hand-wave', to:'hello'},
            // {text: 'Test', icon: 'mdi-account', to : 'test'},
            // {text: 'Planners Table', icon: 'mdi-account-details', to : 'planners_table'},
        ],
  }),

  computed: {
    ...mapState([
      'cadRequestVersion',
      // 'getUpdatedVersion'
      ]),

      authUser(){
        if(this.$store.state.loggedInUser.is_admin == 1){
            this.$store.state.loggedInUser.type ='Admin'
        }

        if(this.$store.state.loggedInUser.is_special_account == 1 || this.$store.state.loggedInUser.is_gc_user == 1 || this.$store.state.loggedInUser.is_ichijo_user == 1 || this.$store.state.loggedInUser.is_rulebook_user == 1){
            this.$store.state.loggedInUser.type ='Planner'
        }

        // if(this.$store.state.loggedInUser.is_special_account == 1){
        //     this.$store.state.loggedInUser.type ='Special'
        // }

        return this.$store.state.loggedInUser;
      },

      canViewMaintenance(){
        if(this.authUser.role.name === 'Admin') return true
        if(typeof _.find(this.authUser.permissions,{ name : 'maintenance-page'}) === 'object' ) return true;
      },

      getCurrentRoute(){
          let route = this.$route.name
          return route.toLowerCase();
      }

  },
  created() {
    this.menu = this.selectedMenu
  },

  beforeDestroy() {
      // Remove the keydown event listener when the component is destroyed
      // window.removeEventListener('keydown', this.handleKeyDown);
  },

  mounted() {
    // window.addEventListener('keydown', this.handleKeyDown);
    this.cadRequestVer().then(() => {
      this.verMasterHeader = this.cadRequestVersion.version
        this.newUpdateVersion();
        // this.getUpdatedVersion()
          // this.getFeedbacks();
    });
  },

  methods: {
    ...mapActions([
        'cadRequestVer',
    ]),

    feedbackOpen(){
      window.open('/feedBack');
    },

    logOpen(){
      window.open('/logs')
    },

    newUpdateVersion(val){
      val = this.cadRequestVersion
        // console.log(val,'val')
        var getToday = moment(this.dateToday);
        var getUpdate = moment(val.created_at).format('YYYY-MM-DD');
        // console.log(getUpdate,'getUpdate')

        var lessDay = getToday.diff(getUpdate, 'days')
        // console.log(lessDay, 'lessDay')

        if(lessDay <= 3){
          this.alert = true;
          this.reminder = true;
            setTimeout(() => {
              this.reminder = false;
            }, 100000);
        }
      },

    //   getFeedbacks(){
    //     axios({
    //         method: "POST",
    //         url: "api/feedbackDatas"
    //     }).then(({data}) => {
    //         this.feedbackData = data;

    //         let getNotif = this.feedbackData.filter((v) => {
    //           return v.created_at.slice(0,10) == this.createdDate;
    //         })
    //         this.feedbackMessages = getNotif ? getNotif.length : ''
    //     })
    // },


    emitDialogValue(value){
      this.$emit('emitDialogValue', value);
    },

    toggleDrawer(val){
        this.$emit("toggleDrawer",val)
    },
    
    goToPage(page){
      if(this.onMasterConfiguration){
        location.href = page
      }
      this.$router.push(page, () => {});
    },
    
    logOut(){
      this.$store.commit('loggedOut');
    },

    // handleContextMenu(event) {
    //     // Prevent the default context menu behavior
    //     event.preventDefault();
    // },
    // handleKeyDown(event) {
    //   // Disable F12 and Ctrl+Shift+I (Windows/Linux) or Cmd+Option+I (Mac)
    //   if ((event.key === 'F12') || ((event.ctrlKey || event.metaKey) && event.shiftKey && event.key === 'I')) {
    //       event.preventDefault();
    //   }
    //   // Disable right-click
    //   if (event.button === 2) {
    //       event.preventDefault();
    //   }
    // },

  },
}
</script>

<style scoped>
  .btn-active{
    background-color: #546e7a !important;
    color: whitesmoke !important;
  }

  .textPosition{
    animation-direction: alternate;
    position: relative;
    animation: myPosition 8s linear infinite;
  }

  @keyframes myPosition {
  0%  {left: 0px;}
  25% {left: -50px;}
  50% {left: -100px;}
  75% {left: -150px;}
  100%  {left: -200px;}
}


</style>
